<div mat-dialog-content>
    If you cancel, your session will be terminated.
  </div>
  <div mat-dialog-actions [align]="'end'">
      <button class="yes-btn" mat-raised-button  [mat-dialog-close]="true">Yes</button>
    <button class="no-btn" mat-raised-button [mat-dialog-close]="false">No</button>
  </div>
  